import { useEffect, useState } from "react";
import { getValidationRunScoringConfigById } from "../services/scoringService";

const useFetchValidationRunScoringConfigById = ({
  setIsLoading,
  configId,
}: any) => {
  const [configData, setConfigData] = useState<any>({});

  useEffect(() => {
    if (configId && configId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getValidationRunScoringConfigById(configId);
          setConfigData(result);
        } catch (err) {
          setConfigData({});
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [configId]);

  return [configData];
};

export default useFetchValidationRunScoringConfigById;
